import { useEffect } from 'react'
import type { MutableRefObject, RefObject } from 'react'

type Params = {
  open: boolean
  containerRef: RefObject<HTMLDivElement | null>
  containerSizeRef: MutableRefObject<{ width: number; height: number }>
  updateContainerSize: () => void
}

export const useImageZoomContainerObserver = ({
  open,
  containerRef,
  containerSizeRef,
  updateContainerSize,
}: Params) => {
  useEffect(() => {
    if (!open) return
    updateContainerSize()

    const el = containerRef.current
    if (!el || typeof ResizeObserver === 'undefined') return

    const observer = new ResizeObserver((entries) => {
      const entry = entries[0]
      if (!entry) return
      containerSizeRef.current = {
        width: entry.contentRect.width,
        height: entry.contentRect.height,
      }
    })

    observer.observe(el)
    return () => {
      observer.disconnect()
    }
  }, [containerRef, containerSizeRef, open, updateContainerSize])
}
